import * as React from 'react';

function Inspired(props) {
	return (
		<svg
			width="60"
			height="60"
			viewBox="0 0 60 60"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M29.9999 59.9999C46.5685 59.9999 59.9999 46.5685 59.9999 29.9999C59.9999 13.4314 46.5685 0 29.9999 0C13.4314 0 0 13.4314 0 29.9999C0 46.5685 13.4314 59.9999 29.9999 59.9999Z"
				fill="#ED68A0"
			/>
			<path
				opacity="0.5"
				d="M36.4286 55.5707C19.8601 55.5707 6.42875 42.1393 6.42875 25.5709C6.42875 16.7189 10.2633 8.76372 16.3612 3.27246C6.64894 8.23837 0 18.3425 0 29.9996C0 46.5681 13.4314 59.9994 29.9998 59.9994C37.7165 59.9994 44.7517 57.085 50.0672 52.2982C45.9753 54.3903 41.34 55.5707 36.4286 55.5707Z"
				fill="#95225B"
			/>
			<path
				d="M34.3641 50.1434C27.6575 50.1434 22.2207 44.7066 22.2207 38H46.5074C46.5074 44.7066 41.0706 50.1434 34.3641 50.1434Z"
				fill="#95225B"
			/>
			<path
				d="M24.7745 24.3743C26.7966 24.3743 28.4358 22.7351 28.4358 20.713C28.4358 18.691 26.7966 17.0518 24.7745 17.0518C22.7525 17.0518 21.1133 18.691 21.1133 20.713C21.1133 22.7351 22.7525 24.3743 24.7745 24.3743Z"
				fill="#7F184C"
			/>
			<path
				d="M45.3888 24.3743C47.4109 24.3743 49.0501 22.7351 49.0501 20.713C49.0501 18.691 47.4109 17.0518 45.3888 17.0518C43.3667 17.0518 41.7275 18.691 41.7275 20.713C41.7275 22.7351 43.3667 24.3743 45.3888 24.3743Z"
				fill="#7F184C"
			/>
			<path
				d="M34.6054 45.1057C31.3229 43.5806 27.6804 43.8022 24.7266 45.3839C26.9461 48.2768 30.4366 50.1436 34.3646 50.1436C36.0957 50.1436 37.7406 49.7789 39.2309 49.1261C38.1378 47.4347 36.57 46.0185 34.6054 45.1057Z"
				fill="#FC4C59"
			/>
			<path
				d="M25.4131 38V39.8956C25.4131 40.6949 26.061 41.3428 26.8602 41.3428H42.3268C43.1261 41.3428 43.7739 40.6948 43.7739 39.8956V38H25.4131Z"
				fill="#F2F2F2"
			/>
			<path
				d="M45.0984 11.5416L47.2397 15.8804C47.4181 16.2419 47.763 16.4924 48.1619 16.5504L52.95 17.2461C53.9546 17.3921 54.3557 18.6267 53.6288 19.3353L50.1641 22.7126C49.8754 22.994 49.7437 23.3993 49.8118 23.7966L50.6297 28.5654C50.8013 29.5659 49.7512 30.3289 48.8526 29.8565L44.5699 27.605C44.2131 27.4174 43.7868 27.4174 43.43 27.605L39.1474 29.8565C38.2488 30.3289 37.1986 29.5659 37.3702 28.5654L38.1881 23.7966C38.2562 23.3993 38.1245 22.9938 37.8359 22.7126L34.3712 19.3353C33.6443 18.6267 34.0454 17.3921 35.05 17.2461L39.8381 16.5504C40.237 16.4924 40.582 16.2418 40.7603 15.8804L42.9016 11.5416C43.351 10.6313 44.6491 10.6313 45.0984 11.5416Z"
				fill="#FFFF00"
			/>
			<path
				d="M44.4495 16.7948L45.3251 18.5691C45.3981 18.717 45.5391 18.8194 45.7023 18.8431L47.6602 19.1276C48.071 19.1872 48.2351 19.6921 47.9378 19.9818L46.5209 21.363C46.4028 21.478 46.3491 21.6438 46.3769 21.8063L46.7113 23.7564C46.7815 24.1655 46.352 24.4775 45.9846 24.2844L44.2333 23.3637C44.0874 23.287 43.9131 23.287 43.7672 23.3637L42.0159 24.2844C41.6484 24.4775 41.219 24.1655 41.2891 23.7564L41.6236 21.8063C41.6514 21.6439 41.5975 21.4781 41.4796 21.363L40.0629 19.9818C39.7657 19.6921 39.9297 19.1872 40.3405 19.1276L42.2985 18.8431C42.4615 18.8193 42.6026 18.7168 42.6756 18.5691L43.5512 16.7948C43.7349 16.4226 44.2657 16.4226 44.4495 16.7948Z"
				fill="#95225B"
			/>
			<path
				d="M26.0984 11.5416L28.2397 15.8804C28.4181 16.2419 28.763 16.4924 29.1619 16.5504L33.95 17.2461C34.9546 17.3921 35.3557 18.6267 34.6288 19.3353L31.1641 22.7126C30.8754 22.994 30.7437 23.3993 30.8118 23.7966L31.6297 28.5654C31.8013 29.5659 30.7512 30.3289 29.8526 29.8565L25.5699 27.605C25.2131 27.4174 24.7868 27.4174 24.43 27.605L20.1474 29.8565C19.2488 30.3289 18.1986 29.5659 18.3702 28.5654L19.1881 23.7966C19.2562 23.3993 19.1245 22.9938 18.8359 22.7126L15.3712 19.3353C14.6443 18.6267 15.0454 17.3921 16.05 17.2461L20.8381 16.5504C21.237 16.4924 21.582 16.2418 21.7603 15.8804L23.9016 11.5416C24.351 10.6313 25.6491 10.6313 26.0984 11.5416Z"
				fill="#FFFF00"
			/>
			<path
				d="M25.4495 16.7948L26.3251 18.5691C26.3981 18.717 26.5391 18.8194 26.7023 18.8431L28.6602 19.1276C29.071 19.1872 29.2351 19.6921 28.9378 19.9818L27.5209 21.363C27.4028 21.478 27.3491 21.6438 27.3769 21.8063L27.7113 23.7564C27.7815 24.1655 27.352 24.4775 26.9846 24.2844L25.2333 23.3637C25.0874 23.287 24.9131 23.287 24.7672 23.3637L23.0159 24.2844C22.6484 24.4775 22.219 24.1655 22.2891 23.7564L22.6236 21.8063C22.6514 21.6439 22.5975 21.4781 22.4796 21.363L21.0629 19.9818C20.7657 19.6921 20.9297 19.1872 21.3405 19.1276L23.2985 18.8431C23.4615 18.8193 23.6026 18.7168 23.6756 18.5691L24.5512 16.7948C24.7349 16.4226 25.2657 16.4226 25.4495 16.7948Z"
				fill="#95225B"
			/>
		</svg>
	);
}

export default Inspired;
